import axios from 'axios';
import { requestInterceptor } from '../network/interceptors/requestInterceptor';
import { responseSuccessInterceptor, responseErrorInterceptor } from '../network/interceptors/responseInterceptor';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://api.eaquahealth.com/api';
// const BASE_URL = 'http://localhost:8000/api';

const apiConfig = axios.create({
    baseURL: BASE_URL,
    timeout: 60000, // Increased timeout to 60 seconds
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    // Ensure credentials are sent for CORS
    withCredentials: true
});

// Add request interceptor
apiConfig.interceptors.request.use(
    requestInterceptor,
    (error) => Promise.reject(error)
);

// Add response interceptor with proper error handling
apiConfig.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor
);

export default apiConfig;
